/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { InputField, InputNumberField } from "../../molecules";
import { ModalWrapper } from "../../../common/modals/ModalWrapper";
import { IExtraInput } from "../../../common/types";
import { Alert, Button, Divider, Form, InputFormWrapper } from "../../atoms";
import { addExtraToFirestore } from "../../../firestore/firestoreService";
import { closeModal } from "../../../redux/data/modals/modalReducer";

export const AddExtraModal: React.FC = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const handleSubmit = async () => {
    try {
      const values: IExtraInput = await form.validateFields();
      setLoading(true);
      await addExtraToFirestore({
        name: values.name,
        price: values.price,
        status: true,
      });
      setLoading(false);
      dispatch(closeModal());
    } catch (errorInfo) {
      setLoading(false);
      if (typeof errorInfo === "string") {
        setError(errorInfo.toUpperCase());
      } else if (errorInfo instanceof Error) {
        setError(errorInfo.message);
      }
    }
  };
  return (
    <ModalWrapper {...props} footer={null}>
      {error !== "" && (
        <Alert message={error} type="error" style={{ marginBottom: 20 }} />
      )}
      <InputFormWrapper>
        <div className="input-form-body">
          <Form
            form={form}
            name="horizontal_login"
            layout="vertical"
            autoComplete="off"
          >
            <InputField
              label="Extra Name"
              name="name"
              rules={[{ required: true, message: "Missing Extra Name" }]}
              placeholder="Extra Name"
              style={{ width: "100%" }}
            />
            <InputNumberField
              label="Price"
              name="price"
              min={0}
              formatter={(value: string) => `€ ${value}`}
              parser={(value: string) => value.replace("€", "")}
              rules={[{ required: true, message: "Missing Price" }]}
              placeholder="Price"
              style={{ width: "100%" }}
            />
            <Divider></Divider>
            <Button
              type="primary"
              className="input-form-btn"
              onClick={handleSubmit}
              loading={loading}
            >
              Add Extra
            </Button>
          </Form>
        </div>
      </InputFormWrapper>
    </ModalWrapper>
  );
};
